// jsaForm/v1/ppe.actions.js

export const makeJsaV1PpeActions = ({ setJsaUi, bump, emitJsaPatch }) => ({
  updateJsaPpe(jsaData, ppeType, value, emitPatch) {
    switch (ppeType) {
      // Eye and Face
      case "ppeEyeFaceSafetyGlasses":
        jsaData.jsaPpeInfo.updatePpeEyeFaceSafetyGlasses(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeEyeFaceSafetyGlasses: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "ppeEyeFaceGoggles":
        jsaData.jsaPpeInfo.updatePpeEyeFaceGoggles(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeEyeFaceGoggles: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "ppeEyeFaceFaceShield":
        jsaData.jsaPpeInfo.updatePpeEyeFaceFaceShield(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeEyeFaceFaceShield: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;

      // Hearing and Head
      case "ppeHearingEarPlugs":
        jsaData.jsaPpeInfo.updatePpeHearingEarPlugs(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeHearingEarPlugs: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "ppeHearingEarMuffs":
        jsaData.jsaPpeInfo.updatePpeHearingEarMuffs(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeHearingEarMuffs: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "ppeHeadHardHat":
        jsaData.jsaPpeInfo.updatePpeHeadHardHat(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeHeadHardHat: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;

      // Hand
      case "ppeHandLeather":
        jsaData.jsaPpeInfo.updatePpeHandLeather(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeHandLeather: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "ppeHandCutResistant":
        jsaData.jsaPpeInfo.updatePpeHandCutResistant(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeHandCutResistant: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "ppeHandChemicalResistant":
        jsaData.jsaPpeInfo.updatePpeHandChemicalResistant(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeHandChemicalResistant: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "ppeHandOther":
        jsaData.jsaPpeInfo.updatePpeHandOther(value);
        const ppeHandFields = { ppeHandOther: value };
        if (!value) {
          ppeHandFields.ppeHandOtherInfo = "";
        }
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch(ppeHandFields, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        setJsaUi({
          v1: (prev) => ({
            ...prev,
            ppe: { ...(prev?.ppe || {}), showJsaPpeHandOtherSection: value },
          }),
        });
        break;
      case "ppeHandOtherInfo":
        jsaData.jsaPpeInfo.updatePpeHandOtherInfo(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeHandOtherInfo: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;

      // Foot
      case "ppeFootSteelToe":
        jsaData.jsaPpeInfo.updatePpeFootSteelToe(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeFootSteelToe: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "ppeFootMetatarsal":
        jsaData.jsaPpeInfo.updatePpeFootMetatarsal(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeFootMetatarsal: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "ppeFootOther":
        jsaData.jsaPpeInfo.updatePpeFootOther(value);
        const ppeFootFields = { ppeFootOther: value };
        if (!value) {
          ppeFootFields.ppeFootOtherInfo = "";
        }
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch(ppeFootFields, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        setJsaUi({
          v1: (prev) => ({
            ...prev,
            ppe: { ...(prev?.ppe || {}), showJsaPpeFootOtherSection: value },
          }),
        });
        break;
      case "ppeFootOtherInfo":
        jsaData.jsaPpeInfo.updatePpeFootOtherInfo(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeFootOtherInfo: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;

      // Protective Clothing
      case "ppeClothingNomex":
        jsaData.jsaPpeInfo.updatePpeClothingNomex(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeClothingNomex: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "ppeClothingTyvek":
        jsaData.jsaPpeInfo.updatePpeClothingTyvek(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeClothingTyvek: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "ppeClothingSlickerSuit":
        jsaData.jsaPpeInfo.updatePpeClothingSlickerSuit(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeClothingSlickerSuit: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "ppeClothingAcidSuit":
        jsaData.jsaPpeInfo.updatePpeClothingAcidSuit(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeClothingAcidSuit: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;

      // Respiratory Protection
      case "ppeRespiratoryProtectionYes":
        jsaData.jsaPpeInfo.updatePpeRespiratoryProtectionYes(value);
        const ppeRespYesFields = { ppeRespiratoryProtectionYes: value };
        if (!value) {
          ppeRespYesFields.ppeRespiratorTypeHalfFace = false;
          ppeRespYesFields.ppeRespiratorTypeFullFace = false;
          ppeRespYesFields.ppeRespiratorTypeCartridge = false;
          ppeRespYesFields.ppeRespiratorTypeScba = false;
          ppeRespYesFields.ppeRespiratorTypeSuppliedAir = false;
        } else {
          ppeRespYesFields.ppeRespiratoryProtectionNo = false;
        }
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch(ppeRespYesFields, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        setJsaUi({
          v1: (prev) => ({
            ...prev,
            ppe: { ...(prev?.ppe || {}), showJsaPpeRespiratorySection: value },
          }),
        });
        break;
      case "ppeRespiratoryProtectionNo":
        jsaData.jsaPpeInfo.updatePpeRespiratoryProtectionNo(value);
        const ppeRespNoFields = { ppeRespiratoryProtectionNo: value };
        if (value) {
          ppeRespNoFields.ppeRespiratoryProtectionYes = false;
          ppeRespNoFields.ppeRespiratorTypeHalfFace = false;
          ppeRespNoFields.ppeRespiratorTypeFullFace = false;
          ppeRespNoFields.ppeRespiratorTypeCartridge = false;
          ppeRespNoFields.ppeRespiratorTypeScba = false;
          ppeRespNoFields.ppeRespiratorTypeSuppliedAir = false;
        }
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch(ppeRespNoFields, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        if (value) {
          setJsaUi({
            v1: (prev) => ({
              ...prev,
              ppe: {
                ...(prev?.ppe || {}),
                showJsaPpeRespiratorySection: false,
              },
            }),
          });
        }
        break;
      case "ppeRespiratorTypeHalfFace":
        jsaData.jsaPpeInfo.updatePpeRespiratorTypeHalfFace(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeRespiratorTypeHalfFace: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "ppeRespiratorTypeFullFace":
        jsaData.jsaPpeInfo.updatePpeRespiratorTypeFullFace(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeRespiratorTypeFullFace: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "ppeRespiratorTypeCartridge":
        jsaData.jsaPpeInfo.updatePpeRespiratorTypeCartridge(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeRespiratorTypeCartridge: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "ppeRespiratorTypeScba":
        jsaData.jsaPpeInfo.updatePpeRespiratorTypeScba(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeRespiratorTypeScba: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "ppeRespiratorTypeSuppliedAir":
        jsaData.jsaPpeInfo.updatePpeRespiratorTypeSuppliedAir(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeRespiratorTypeSuppliedAir: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;

      // Comments
      case "ppeComments":
        jsaData.jsaPpeInfo.updatePpeComments(value);
        if (emitPatch) {
          const patch = jsaData.jsaPpeInfo.toPatch({ ppeComments: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;

      default:
        break;
    }
    bump();
  },
});
